import StencilHTMLElement from "./stencil-element";

class CartDrawer extends StencilHTMLElement {
  lineItems;

  constructor() {
    super();
  }

  connectedCallback() {
    // console.log(`hello from cartdrawer`);
    this.init();
    this.lineItems = this.querySelectorAll('card-line-item');
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    //const lineItemRemoveButtons = this.querySelectorAll('.cart-drawer-line-item-remove');
    //this.addEventListener('click', this.onCartDrawerClick.bind(this));
  }

}

export default CartDrawer;